export const loadingText = '数据加载中，请稍候...';
export const emptyText = '暂无数据';

// 分页条上的 pageSize 下拉框
export const pageSizeItems = [5, 10, 20, 50, 100];

// 默认的分页查询参数
export const initPageParams = { pageNum: 1, pageSize: pageSizeItems[1] };
